<template>
  <div class="perfect clearfix">
    <a-form
      :labelCol="formItemLayout.labelCol"
      :wrapperCol="formItemLayout.wrapperCol"
      layout="vertical"
      labelAlign="left"
      @submit="handleSubmit"
      :form="modelForm"
    >
      <div class="header">
        <a-button @click="goBack" type="primary">
          返回
        </a-button>
        <a-button @click="btnSave" style="margin-left:20px" type="primary">
          保存
        </a-button>
      </div>

      <div class="content">
        <div class="ser">
          <div style="margin-bottom:10px" class="title">项目编辑</div>

          <a-form-item label="项目名称：">
            <a-input
              v-decorator="[
                'itemName',
                {
                  rules: [
                    {
                      required: true,
                      message: '师生共创：'
                    }
                  ]
                }
              ]"
            />
          </a-form-item>
          <a-form-item label="负责人">
            <a-input
              disabled
              v-decorator="[
                'leader',
                {
                  rules: [
                    {
                      required: true,
                      message: '负责人'
                    }
                  ]
                }
              ]"
            />
          </a-form-item>
          <a-form-item label="负责人手机">
            <a-input
              disabled
              v-decorator="[
                'telephone',
                {
                  rules: [
                    {
                      required: true,
                      message: '负责人手机'
                    }
                  ]
                }
              ]"
            />
          </a-form-item>
          <a-form-item label="负责人邮箱">
            <a-input
              disabled
              v-decorator="[
                'email',
                {
                  rules: [
                    {
                      required: true,
                      message: '负责人邮箱'
                    }
                  ]
                }
              ]"
            />
          </a-form-item>
          <a-form-item label="学校">
            <a-input
              disabled
              v-decorator="[
                'school',
                {
                  rules: [
                    {
                      required: true,
                      message: '学校'
                    }
                  ]
                }
              ]"
            />
          </a-form-item>
          <a-form-item label="院系">
            <a-input
              disabled
              v-decorator="[
                'faculty',
                {
                  rules: [
                    {
                      required: true,
                      message: '院系'
                    }
                  ]
                }
              ]"
            />
          </a-form-item>
          <a-form-item label="学号">
            <a-input
              disabled
              v-decorator="[
                'studyNo',
                {
                  rules: [
                    {
                      required: true,
                      message: '学号'
                    }
                  ]
                }
              ]"
            />
          </a-form-item>
          <a-form-item label="学历">
            <a-input
              disabled
              v-decorator="[
                'education',
                {
                  rules: [
                    {
                      required: true,
                      message: '学历'
                    }
                  ]
                }
              ]"
            />
          </a-form-item>
          <a-form-item label="入学时间">
            <a-input
              disabled
              v-decorator="[
                'enrollDate',
                {
                  rules: [
                    {
                      required: true,
                      message: '入学时间'
                    }
                  ]
                }
              ]"
            />
          </a-form-item>
          <a-form-item label="毕业时间">
            <a-input
              disabled
              v-decorator="[
                'graduateDate',
                {
                  rules: [
                    {
                      required: true,
                      message: '毕业时间'
                    }
                  ]
                }
              ]"
            />
          </a-form-item>
          <a-form-item label="专业名称">
            <a-input
              disabled
              v-decorator="[
                'major',
                {
                  rules: [
                    {
                      required: true,
                      message: '专业名称'
                    }
                  ]
                }
              ]"
            />
          </a-form-item>
          <a-form-item label="省份">
            <a-input
              disabled
              v-decorator="[
                'province',
                {
                  rules: [
                    {
                      required: true,
                      message: '省份'
                    }
                  ]
                }
              ]"
            />
          </a-form-item>
          <a-form-item label="项目进展">
            <a-select
              placeholder="项目进展"
              v-decorator="[
                'itemProgress',
                {
                  rules: [{ required: true, message: '请选择项目进展' }]
                }
              ]"
            >
              <a-select-option
                v-for="(item, index) in ProgressData"
                :key="index"
                :value="item.name"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="学校科技成果转化">
            <a-select
              placeholder="学校科技成果转化"
              v-decorator="[
                'resultTransfer',
                {
                  rules: [{ required: true, message: '请选择学校科技成果转化' }]
                }
              ]"
            >
              <a-select-option
                v-for="(item, index) in selectStatus"
                :key="index"
                :value="item.name"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="师生共创">
            <a-select
              placeholder="师生共创"
              v-decorator="[
                'bothInvention',
                {
                  rules: [{ required: true, message: '请选择师生共创' }]
                }
              ]"
            >
              <a-select-option
                v-for="(item, index) in selectStatus"
                :key="index"
                :value="item.name"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item label="负责人为科技成果的完成人或所有人">
            <a-select
              placeholder="负责人科技成果"
              v-decorator="[
                'competitionOwner',
                {
                  rules: [{ required: true, message: '请选择师生共创' }]
                }
              ]"
            >
              <a-select-option
                v-for="(item, index) in selectStatus"
                :key="index"
                :value="item.name"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="负责人为科技成果的第一完成人或所有人">
            <a-select
              placeholder="负责人科技成果"
              v-decorator="[
                'competitionFirst',
                {
                  rules: [
                    {
                      required: true,
                      message: '请选择负责人为科技成果的第一完成人或所有人'
                    }
                  ]
                }
              ]"
            >
              <a-select-option
                v-for="(item, index) in selectStatus"
                :key="index"
                :value="item.name"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item
            label="国家级重大丶重点科技研究项目的科研项目的科研成果转化项目"
          >
            <a-select
              placeholder="重点科技研究项目"
              v-decorator="[
                'importantItem',
                {
                  rules: [
                    {
                      required: true,
                      message: '请选择负责人为科技成果的第一完成人或所有人'
                    }
                  ]
                }
              ]"
            >
              <a-select-option
                v-for="(item, index) in selectStatus"
                :key="index"
                :value="item.name"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="是否获得过投资">
            <a-select
              placeholder="是否获得过投资"
              v-decorator="[
                'investment',
                {
                  rules: [
                    {
                      required: true,
                      message: '请选择是否获得过投资'
                    }
                  ]
                }
              ]"
            >
              <a-select-option
                v-for="(item, index) in selectStatus"
                :key="index"
                :value="item.name"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="隐私设置">
            <a-select
              placeholder="隐私设置"
              v-decorator="[
                'privateSetting',
                {
                  rules: [
                    {
                      required: true,
                      message: '请选择隐私设置'
                    }
                  ]
                }
              ]"
            >
              <a-select-option
                v-for="(item, index) in PrivacyData"
                :key="index"
                :value="item.name"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="所属行业">
            <a-select
              placeholder="所属行业"
              mode="multiple"
              v-decorator="[
                'matchFieldDictDOS',
                {
                  rules: [
                    {
                      required: true,
                      message: '请选择所属行业'
                    }
                  ]
                }
              ]"
            >
              <a-select-option
                v-for="(item, index) in selectJobs"
                :key="index"
                :value="item.id"
              >
                {{ item.field }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </div>
        <div class="ser">
          <div class="title">
            项目概述
          </div>
          <a-form-item :wrapper-col="{ span: 24 }">
            <a-textarea
              v-decorator="[
                'itemIntro',
                {
                  rules: [
                    {
                      required: true,
                      message: '请输入项目概述'
                    }
                  ]
                }
              ]"
              placeholder="项目概述"
              :rows="10"
            />
          </a-form-item>

          <div class="title">
            项目成员信息
            <a-button
              class="editable-add-btn"
              style="float:right;margin:10px 10px 0 0"
              @click="AddMembers"
            >
              添加项目成员
            </a-button>
          </div>
          <a-table
            tableLayout="fixed"
            :data-source="studentData"
            :rowKey="studentData => studentData.id"
          >
            <a-table-column title="成员姓名" :ellipsis="true" dataIndex="name">
            </a-table-column>
            <a-table-column title="成员学号" dataIndex="studentNo">
            </a-table-column>
            <a-table-column title="成员角色" dataIndex="role"> </a-table-column>
            <a-table-column title="操作" dataIndex="operation">
              <template slot-scope="id, studentData">
                <a-popconfirm
                  title="确定删除?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="btnDelectStu(studentData.id)"
                >
                  <a>删除</a>
                </a-popconfirm>
                <div class="border"></div>
                <a @click="() => btnEditStu(studentData.id)">编辑</a>
              </template>
            </a-table-column>
          </a-table>
          <div class="title">
            导师信息
            <a-button
              class="editable-add-btn"
              style="float:right;margin:10px 10px 0 0"
              @click="AddTeacher"
            >
              添加导师
            </a-button>
          </div>
          <a-table
            tableLayout="fixed"
            :data-source="teacherData"
            :rowKey="teacherData => teacherData.id"
          >
            <a-table-column title="导师姓名" :ellipsis="true" dataIndex="name">
            </a-table-column>
            <a-table-column title="导师学号" dataIndex="studentNo">
            </a-table-column>
            <a-table-column title="导师角色" dataIndex="role"> </a-table-column>
            <a-table-column title="操作" dataIndex="operation">
              <template slot-scope="id, teacherData">
                <a-popconfirm
                  title="确定删除?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="btnDelectTea(teacherData.id)"
                >
                  <a>删除</a>
                </a-popconfirm>
                <div class="border"></div>
                <a @click="() => btnEditTea(teacherData.id)">编辑</a>
              </template>
            </a-table-column>
          </a-table>
        </div>
      </div>
    </a-form>

    <a-modal
      v-model="modalVisibleStudent"
      :title="modelNameStudent"
      @ok="handleOkAddListStudent"
    >
      <a-form
        :form="modelFormStudent"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 12 }"
        @submit="handleSubmitStudent"
      >
        <a-form-item label="检索姓名/学号">
          <div class="global-search-wrapper" style="width: 300px">
            <a-auto-complete
              allowClear
              @search="searchDataStudent"
              style="width: 100%"
              option-label-prop="title"
              @select="onSelect"
              placeholder="检索姓名/学号"
              v-decorator="[
                'studentId',
                {
                  rules: [{ required: true, message: '请选择学生' }]
                }
              ]"
            >
              <template slot="dataSource">
                <a-select-option
                  v-for="item in dataSource"
                  :key="item.id.toString()"
                  :title="item.name.toString()"
                >
                  {{ item.name }}
                </a-select-option>
              </template>
            </a-auto-complete>
          </div>
        </a-form-item>
        <a-form-item label="选择角色" v-if="selectFlagMember == 1">
          <a-select
            placeholder="请选择角色"
            v-decorator="[
              'role',
              {
                rules: [{ required: true, message: '请选择角色' }]
              }
            ]"
          >
            <a-select-option
              v-for="(item, index) in rolesData"
              :key="index"
              :value="item.roleName"
            >
              {{ item.roleName }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
    <!-- <a-modal
      v-model="modalVisibleTeacher"
      :title="modelNameTeacher"
      @ok="handleOkAddListTeacher"
    >
      <a-form
        :form="modelFormTeacher"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 12 }"
        @submit="handleSubmit"
      >
        <a-form-item label="导师姓名">
          <a-input
            placeholder="请输入导师姓名"
            v-decorator="[
              'activityName',
              {
                rules: [{ required: true, message: '请输入导师姓名' }]
              }
            ]"
          />
        </a-form-item>
        <a-form-item label="导师学号">
          <a-input
            placeholder="请输入导师学号"
            v-decorator="[
              'activityName',
              {
                rules: [{ required: true, message: '请输入导师学号' }]
              }
            ]"
          />
        </a-form-item>
        <a-form-item label="选择角色">
          <a-select
            placeholder="请选择角色"
            v-decorator="[
              'nationAwardConditition',
              {
                rules: [{ required: true, message: '请选择角色' }]
              }
            ]"
          >
            <a-select-option
              v-for="(item, index) in selectStatus"
              :key="index"
              :value="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      editId: this.$route.params.id,
      modalVisible: false,
      modalVisibleTeacher: false,
      modalVisibleStudent: false,
      selectFlag: '',
      modelNameStudent: '',
      modelNameTeacher: '',
      studentData: [],
      teacherData: [],
      formItemLayout: {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 }
      },
      ProgressData: [
        {
          name: '创意计划阶段'
        },
        {
          name: '已注册公司运营'
        },
        {
          name: '已注册社会组织'
        }
      ],
      modelFormStudent: this.$form.createForm(this, {
        name: 'modelFormStudent'
      }),
      modelFormTeacher: this.$form.createForm(this, {
        name: 'modelFormTeacher:'
      }),
      modelForm: this.$form.createForm(this, {
        name: 'modelForm:'
      }),
      selectStatus: [
        {
          name: '是',
          id: 0
        },
        {
          name: '否',
          id: 1
        }
      ],
      PrivacyData: [
        {
          name: '向投资人公开'
        },
        {
          name: '保密'
        }
      ],
      rolesData: [],
      role: '',
      dataSource: [],
      addMembersId: '',
      editItemId: '',
      selectJobs: [],
      selectFlagMember: ''
    }
  },
  methods: {
    getJobs() {
      this.$http(this.$api.GETALLJOBS).then(r => {
        console.log(r)
        this.selectJobs = r.data
      })
    },
    goBack() {
      this.$router.push({ name: 'matchAdministrationN' })
    },
    btnSave() {
      this.selectFlag = 1
      this.handleSubmit()
    },
    getDetailData() {
      let data = {
        id: this.editId
      }
      this.$http(this.$api.GETDETAILDATA, data).then(r => {
        this.$nextTick(() => {
          let flagData = r.data
          this.modelForm.setFieldsValue({
            itemName: flagData.itemName,
            leader: flagData.leader,
            telephone: flagData.telephone,
            email: flagData.email,
            school: flagData.school,
            faculty: flagData.faculty,
            studyNo: flagData.studyNo,
            education: flagData.education,
            enrollDate: flagData.enrollDate,
            graduateDate: flagData.graduateDate,
            major: flagData.major,
            province: flagData.province,
            itemProgress: flagData.itemProgress,
            resultTransfer: flagData.resultTransfer,
            bothInvention: flagData.bothInvention,
            competitionOwner: flagData.competitionOwner,
            competitionFirst: flagData.competitionFirst,
            importantItem: flagData.importantItem,
            investment: flagData.investment,
            privateSetting: flagData.privateSetting,
            matchFieldDictDOS: flagData.matchFieldDictDOS,
            itemIntro: flagData.itemIntro
          })
        })
      })
    },
    btnDelectStu(id) {
      console.log(id)
      let data = { id }
      this.$http(this.$api.DELECTMEMBER, data).then(() => {
        this.seeMember()
        this.$notification.open({
          type: 'success',
          message: '删除成员',
          description: '删除成功'
        })
      })
    },
    btnDelectTea(id) {
      let data = { id }
      this.$http(this.$api.DELECTMEMBER, data).then(() => {
        this.seeTeacher()
        this.$notification.open({
          type: 'success',
          message: '删除成员',
          description: '删除成功'
        })
      })
    },
    btnEditStu(id) {
      console.log(id)
      this.selectFlagMember = 1
      this.role = 0
      this.editItemId = id
      this.getRoles()
      this.modalVisibleStudent = true
      this.modelNameStudent = '配置角色'
    },
    btnEditTea(id) {
      console.log(id)
      this.selectFlagMember = 1
      this.role = 1
      this.editItemId = id
      this.getRoles()
      this.modalVisibleStudent = true
      this.modelNameStudent = '配置角色'
    },
    onSelect(value) {
      this.addMembersId = value
    },
    searchDataStudent(val) {
      console.log(val)
      let data = {
        roles: 0,
        name: val
      }
      this.$http(this.$api.SEARCHMEMBER, data).then(r => {
        this.dataSource = r.data.length > 0 ? r.data : []
        console.log(this.dataSource)
      })
    },
    //项目成员
    seeMember() {
      let data = {
        matchId: this.editId,
        roleType: 0
      }
      this.$http(this.$api.GETTEACHERORSTUDENT, data).then(r => {
        console.log(r)
        this.studentData = r.data
      })
    },
    //项目导师
    seeTeacher() {
      let data = {
        matchId: this.editId,
        roleType: 1
      }
      this.$http(this.$api.GETTEACHERORSTUDENT, data).then(r => {
        console.log(r)
        this.teacherData = r.data
      })
    },
    AddMembers() {
      this.selectFlagMember = 2
      this.role = 0
      this.modelNameStudent = '添加项目成员'
      this.modalVisibleStudent = true
    },
    AddTeacher() {
      this.selectFlagMember = 2
      this.role = 1
      this.modelNameStudent = '添加项目成员'
      this.modalVisibleStudent = true
    },
    handleOkAddList() {
      this.handleSubmit()
    },
    //学生或者老师添加人员
    handleOkAddListStudent() {
      this.handleSubmitStudent()
    },
    handleSubmitStudent() {
      this.modelFormStudent.validateFields((err, data) => {
        if (!err) {
          this.modalVisible = false
          console.log('Received values of form: ', data)

          if (this.selectFlagMember == 1) {
            data.roleType = this.role
            data.matchId = this.editId
            //添加
            this.$http(this.$api.EDITMEMBER, data).then(r => {
              console.log(r)
              this.seeMember()
              this.seeTeacher()
              this.$notification.open({
                type: 'success',
                message: '人员编辑',
                description: '编辑成功'
              })
            })
          } else if (this.selectFlagMember == 2) {
            //编辑
            data.roleType = this.role
            data.matchId = this.editId
            data.id = this.editItemId
            this.$http(this.$api.ADDMEMBER, data).then(() => {
              this.seeMember()
              this.seeTeacher()
              this.modelFormStudent.resetFields()
              this.$notification.open({
                type: 'success',
                message: '人员添加',
                description: '添加成功'
              })
            })
          }
        }
        this.modalVisibleStudent = false
      })
    },
    getRoles() {
      let data = {
        studentType: this.role
      }
      console.log(this.role)
      this.$http(this.$api.GETROLES, data).then(r => {
        this.rolesData = r.data
      })
    },
    handleSubmit() {
      this.modelForm.validateFields((err, data) => {
        if (!err) {
          this.modalVisible = false
          console.log('Received values of form: ', data)
          if (this.selectFlag == 1) {
            data.id = parseInt(this.editId)
            //编辑基金
            this.$http(this.$api.UPDATEMATCHITEM, data).then(r => {
              console.log(r)
              this.getDetailData()
              this.$notification.open({
                type: 'success',
                message: '编辑参赛人信息',
                description: '参赛人信息编辑成功'
              })
            })
          }
        }
      })
    }
  },
  created() {
    this.seeMember()
    this.seeTeacher()
    this.getDetailData()
    this.getJobs()
    console.log(this.$route.params.id)
  }
}
</script>
<style scoped lang="less">
.perfect {
  width: 100%;
  height: 100%;
  padding: 40px;
  box-sizing: border-box;
  overflow: scroll;
  .header {
    padding: 0 20px;
    box-sizing: border-box;
  }
  .content {
    width: 100%;
    .ser {
      float: left;
      width: calc(100% - 400px);
      padding: 20px;
      border-radius: 5px;
      .title {
        font-size: 15px;
        font-weight: bold;
        text-align: center;
        height: 50px;
        line-height: 50px;
        background-color: #eff0f4;
      }
    }
    .ser:nth-child(1) {
      width: 400px;
      box-sizing: border-box;
      // border-right: 1px solid #979797;
    }
  }
}
</style>
